import type {
  ProgressBarDeviceConfig,
  ResolvedProgressBarDeviceConfig,
} from "@intelligems/ig-types";

export function createShippingProgressBarConfig(
  widget: ResolvedProgressBarDeviceConfig,
  threshold: number
): ProgressBarDeviceConfig {
  const { textReplacements } = widget.variables;
  return {
    widget,
    breakpoints: [
      {
        value: threshold,
        label: textReplacements.tooltipTemplate,
        completeText:
          textReplacements.currentUnlockedTemplate ??
          textReplacements.allTiersUnlockedTemplate,
        incompleteText: textReplacements.buyMoreTemplate,
        tooltipEnabled: textReplacements.tooltipEnabled,
        active: {
          iconId: textReplacements.activeIconId,
          backgroundIconId: textReplacements.activeBackgroundIconId,
        },
        inactive: {
          iconId: textReplacements.inactiveIconId,
          backgroundIconId: textReplacements.inactiveBackgroundIconId,
        },
        reward: {
          freeShipping: true,
        },
      },
    ],
  };
}
